import { createReducer } from '@reduxjs/toolkit';
import { responseFailed } from 'actionCreators/error';
import { deleteTokenSuccess } from 'actionCreators/token';

const errorReducer = createReducer({
  code: '',
  message: '',
  isError: false
}, (builder) => {
  builder.addCase(responseFailed, (state, action) => {
    const { code, message } = action.payload.error || { code: '', message: 'Loading error' };
    state.code = code;
    state.message = message;
    state.isError = true;
  });

  builder.addCase(deleteTokenSuccess, (state) => {
    state.code = '403';
    state.message = 'Session expired due to inactivity';
    state.isError = true;
  });
});

export { errorReducer };
